// Constantes del feature traspasos

export const TRASPASO_ESTADO = {
    PENDIENTE: 'PENDIENTE',
    TRASPASADO: 'TRASPASADO',
};

export const TRASPASO_ESTADO_LABELS = {
    PENDIENTE: 'Pendiente',
    TRASPASADO: 'Traspasado',
};

export const TRASPASO_ESTADO_CHIP = {
    PENDIENTE: 'warning',
    TRASPASADO: 'success',
};
